<template>
  <div class="online-help-wrapper" id="online-help-wrapper">
    <!-- 活动标题 -->
    <div v-wechat-title="'十里坡剑神，练级邀请...'"></div>
    <div :class="`online-home-wrapper home-${homeShow}`">
      <div class="hidden-box ignore-a"></div>
      <div class="online-help-page">
        <div class="main">
          <div class="container">
            <div class="content-box">
              <div class="detail-btn" @click="detailShow = true"></div>
              <div class="help-btn" @click="onHelp"></div>
              <div class="join-btn"><a :href="url"></a></div>
              <div @click="goToWiki" class="wechat-btn" v-if="link">
                <div>
                  <img
                    src="../../../../assets/images/active/hjwq/online/wechat_btn.png"
                    alt="WIKI"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 规则详情-弹窗 -->
        <div class="popup_wrap detail-wrap" v-show="detailShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="detailShow">
              <div class="detail-content-wrapper-bg">
                <div class="detail-content-wrapper">
                  <div class="detail-content"></div>
                </div>
              </div>
              <div class="close" @click="detailShow = false"></div>
            </div>
          </transition>
        </div>
        <!-- 已经帮助过-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap help-wrap-1 help-wrap"
          v-show="helpShow1"
          @click="helpShow1 = false"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="helpShow1"></div>
          </transition>
        </div>
        <!-- 助力已达上限-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap help-wrap-2 help-wrap"
          v-show="helpShow2"
          @click="helpShow2 = false"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="helpShow2"></div>
          </transition>
        </div>
        <!-- 助力成功-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap help-wrap-3 help-wrap"
          v-show="helpShow3"
          @click="helpShow3 = false"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="helpShow3"></div>
          </transition>
        </div>
        <!-- 帮助自己-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap help-wrap-4 help-wrap"
          v-show="helpShow4"
          @click="helpShow4 = false"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="helpShow4"></div>
          </transition>
        </div>
        <!-- 好友暂未绑定角色-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap help-wrap-5 help-wrap"
          v-show="helpShow5"
          @click="helpShow5 = false"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="helpShow5"></div>
          </transition>
        </div>
        <!-- 好友暂未绑定角色-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap help-wrap-6 help-wrap"
          v-show="helpShow6"
          @click="helpShow6 = false"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="helpShow6"></div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { onHelp, onHelpInit, getLink } from "../api";
import { wechatBrowser, getTimeStamp, analysisParams } from "@/utils/utils";

export default {
  name: "demo",
  components: {},
  data() {
    return {
      homeShow: false,
      detailShow: false,
      helpShow1: false,
      helpShow2: false,
      helpShow3: false,
      helpShow4: false,
      helpShow5: false,
      helpShow6: false,
      url: `https://h5.qingcigame.com/hjwq/online/enter${getTimeStamp()}`,
      isWechat: false,
      link: ""
    };
  },
  mounted() {
    this.monitoringEquipment();
    this.forceLandscapeScreenHandle();
    this.onWindowSizeChanged();
    this.startLoading();
    this.handleShare();
    this.init();
  },
  computed: {},
  methods: {
    init() {
      const params = analysisParams(window.location.href);
      getLink().then(res => {
        if (res.code === 200) {
          this.link = res.data.link;
        }
      });
      if (!params.id) return;
      onHelpInit({ friend_id: params.id }).then(response => {
        this.homeShow = true;
        if (Number(response.code) == 200) {
          return;
        }
        // 请登录
        if (Number(response.code) == 401) {
          this.tipsMessage(response.message, 2000);
          return;
        }
        // 微信授权
        if (Number(response.code) == 302) {
          window.location.href = `${
            wechatBrowser() ? response.data.url : response.data.qq_url
          }?callback=${encodeURI(window.location.href)}`;
          return;
        }
        this.tipsMessage(response.message, 2000);
      });
    },
    goToWiki() {
      // 微信内的网页如需打开小程序请使用微信开放标签-小程序跳转按钮
      window.location.href = this.link;
    },
    tipsMessage(message, times) {
      this.tipsShow = true;
      this.tips = message;
      setTimeout(() => {
        this.tipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.tipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.tipsShow = false;
        this.tips = "";
      }, times);
    },
    monitoringEquipment() {
      // if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/hjwq/online/pc${getTimeStamp()}`;
      if (
        navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        "micromessenger"
      ) {
        return;
      } else {
        this.paymentList = this.paymentList2;
      }
    },
    // 适配
    forceLandscapeScreenHandle() {
      if (document.activeElement.nodeName === "INPUT") return; // 兼容安卓
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
        fontH = window.innerWidth > window.innerHeight ? height : width;

      const el = document.getElementById("online-help-wrapper");
      let style = "";
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${width /
          2}px center;width:${height}px;height:${width}px`;
        // this.homeShow = true;
      } else {
        // 横板
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + "px";
          style = `transform:rotate(0deg);transform-origin:${width /
            2}px center;width:${width}px;height:${height}px`;
          // this.homeShow = true;
          if (el) el.style = style;
        }, 300);
      }

      if (el) el.style = style;
    },
    onWindowSizeChanged() {
      window.addEventListener("resize", this.forceLandscapeScreenHandle);
    },
    isReloadWindow(event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance &&
            window.performance.navigation &&
            window.performance.navigation.type === 2))
      );
    },
    startLoading() {
      // 防止第二次进入 微信底部有一个返回条，造成布局问题
      if (this.isReloadWindow()) {
        window.location.reload();
        return;
      }
    },
    onHelp() {
      const params = analysisParams(window.location.href);
      if (!params.id) return;
      onHelp({ friend_id: params.id }).then(response => {
        if (Number(response.code) == 200) {
          this.helpShow3 = true;
          return;
        }
        // 好友未绑定角色
        if (Number(response.code) == 401) {
          this.helpShow5 = true;
          return;
        }
        // 已达上限
        if (Number(response.code) == 406) {
          this.helpShow2 = true;
          return;
        }
        // 帮助自己
        if (Number(response.code) == 404) {
          this.helpShow4 = true;
          return;
        }
        // 已经帮助
        if (Number(response.code) == 403) {
          this.helpShow1 = true;
          return;
        }
        // 用户已完成
        if (Number(response.code) == 407) {
          this.helpShow6 = true;
          return;
        }
        // 微信授权
        if (Number(response.code) == 302) {
          window.location.href = `${
            wechatBrowser() ? response.data.url : response.data.qq_url
          }?callback=${encodeURI(window.location.href)}`;
          return;
        }
        this.tipsMessage(response.message, 2000);
      });
    },
    handleShare() {
      const ua = navigator.userAgent.toLowerCase();
      this.isWechat =
        (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0]) ===
        "micromessenger";
      this.setShare({
        link: window.location.href,
        title: "十里坡剑神，练级邀请...",
        imgUrl:
          "https://download4.qcplay.com/qcgame-admin/4fZWdOR6UfUBuOZgDyP9EV3NJ2RRxNU9mHSWBjst.png",
        desc: "公测上线活动，练级拿壕礼，快快加入吧!",
        otherConfig: {
          openTagList: ["wx-open-launch-weapp"]
        }
      });
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/online/help/index.vue